import { render, staticRenderFns } from "./CsPrivacyPolicy.vue?vue&type=template&id=401142cb&scoped=true"
import script from "./CsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./CsPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "401142cb",
  null
  ,true
)

export default component.exports